<template>
  <div id="hodeconfMain">
    <div id="hodeWrap">
      <div class="download-tips" v-show="downloadTips">
        TIPS: 每天仅可下载数据四次，请明天再试
      </div>
      <a id="downloadData" :href="downloadUrl" download></a>
      <div class="content" v-for="(block,index) in items" :key='index'>
        <template v-if="selItem[index]">

          <div class="content-top">
            <div class="top-title ellipsis">
              <span>{{typeName(index)}}</span>
              <span class="lgt-tip" :title="tipText(index)">{{
                tipText(index)
                }}</span>
            </div>
            <div class="top-right">
              <el-select v-model="date[index]" placeholder="请选择" v-if="index === 'lgt'" class="quarter-select" size="mini" @change="onSelectChange">
                <el-option
                  v-for="item in quarterOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <calendar v-else  :date.sync="date[index]" :dateList.sync="dateList[index]" :type="index"
                :currDate='configInfo[index].stopDate' @click='downloadData(index)'></calendar>
              <div class="btn" v-if="index !== 'lgt'" readonly='raadonly' @click='downloadData(index)'>
                下载所有数据
              </div>
            </div>

          </div>
          <div class="content-container">
            <div v-for="item in items[index]" :key='item.value'
              v-bind:class="[itemSelected === item.value && typeSelected === index?'block-selected':'']"
              class="content-block" @click='selectItem(item)' :id="'anchor-'+item.type+item.value">
              <div class="block-title">
                {{item.title}}
                <div class="title-tips" @mouseenter='target(item)'>?
                  <div class="tips">
                    <div class="tips-content" v-for="(item,index) in item.tips" :key="index">{{item}}</div>
                  </div>
                </div>
              </div>
              <component v-bind:is="item.type+item.value" :resize="resize" :resizeType="resizeType"
                :type="typeList[item.type+item.value]" :color="themeColor[theme]" :config="configInfo[index]"
                :date="date[index]">
                <!-- 组件在 vm.currentview 变化时改变！ -->
              </component>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import calendar from './mod/calendar';
import industryblock from './block/industryblock';
import baseblock from './block/baseblock';
import lgtblock from './block/lgtblock';
import lgtIndustryblock from './block/lgtIndustryblock.vue';
import util from '../utils/util';

// 接口参数映射前端标识
const KEYMAP = {
  'lgt': 1,
  'ggt': 2
};
const REVERSED_KEYMAP = Object.entries(KEYMAP).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

const HOUR_TO_SEC = 3600;
const BACK_HOURS = 9;
const SEC_TO_MSILLISEC = 1000;

export default {
  name: 'areablock',
  components: {
    calendar,
    lgtsctj:lgtblock,
    lgtzstj:lgtblock,
    lgthytj:lgtIndustryblock,
    lgtzcgtj:lgtblock,
    ggtsctj: baseblock,
    ggtzstj: baseblock,
    ggthytj: industryblock,
    ggtzcgtj: baseblock,
  },
  props: ['selected', 'items', 'resize', 'resizeType', 'theme'],
  created: function() {
    // 客户端方法获取
    API.use({
      method: 'Quote.getServerTime',
      success: result => {
        this.handleNowTime(result*SEC_TO_MSILLISEC);
      },
      error: e => {
        this.handleNowTime();
      },
      notClient: () => {
        this.handleNowTime();
      }
    });
    this.getSwitchDate();
  },
  mounted() {
    const hodeconfMain = document.getElementById('hodeconfMain');
    hodeconfMain.onscroll = e => {
      const hodeWrap = document.getElementById('hodeWrap');
      if (hodeconfMain.scrollTop + 10 > hodeWrap.offsetHeight - document.body.clientHeight) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.setItemShow();
        }, 200);
      }
    };
  },
  data() {
    return {
      timer: '',
      limit: 0,
      currDate: 0,
      date: {
        lgt: '',
        ggt: ''
      },
      dateList: {
        lgt: [],
        ggt: []
      },
      configInfo: {
        lgt: {
          stopDate: 0,
          year: 2018,
          // 开关配置时间
          switchChangeTime: '',
        },
        ggt: {
          stopDate: 0,
          year: 2018,
          switchChangeTime: '',
        }
      },
      selItem: { lgt: true, ggt: true },
      quarterOptions: [],
      typeList: {
        lgtsctj: {
          code_key: 'code',
          name_key: 'name',
          key: 'market',
          name: '市场',
          type: 1,
          typename: '陆股通',
        },
        lgtzstj: {
          code_key: 'code',
          name_key: 'name',
          key: 'index',
          name: '指数',
          type: 1,
          typename: '陆股通'
        },
        lgtzcgtj: {
          code_key: 'code',
          name_key: 'name',
          name: '重仓股',
          key: 'stock',
          type: 1,
          typename: '陆股通'
        },
        lgthytj: {
          code_key: 'code',
          name_key: 'name',
          name: '行业',
          type: 1,
          key: 'industry',
          typename: '陆股通'
        },
        ggtsctj: {
          code_key: 'market_code',
          name_key: 'market_name',
          name: '地区',
          key: 'market',
          type: 2,
          typename: '港股通'
        },
        ggtzstj: {
          code_key: 'index_code',
          name_key: 'index_name',
          name: '指数',
          key: 'index',
          type: 2,
          typename: '港股通'
        },
        ggtzcgtj: {
          code_key: 'stock_code',
          name_key: 'stock_name',
          name: '重仓股',
          key: 'stock',
          type: 2,
          typename: '港股通'
        },
        ggthytj: {
          type: 2,
          typename: '港股通'
        }
      },
      downloadUrl: '',
      downloadTips: false,
      themeColor: {
        black: {
          color: [
            '#0096ff',
            '#02e2f4',
            '#05aea8',
            '#7992b1',
            '#ffdb5c',
            '#ff9f7f',
            '#fb7293',
            '#e062ae',
            '#e690d1',
            '#e7bcf3',
            '#9d96f5',
            '#8378ea',
            '#96bfff',
            '#c52b12',
            '#dd6b66',
            '#e69d87',
            '#eedd78',
            '#8dc1a9',
            '#759aa0',
            '#73b9bc',
            '#749f83',
            '#6e7074',
            '#546570',
            '#2f4554',
            '#bda29a',
            '#c4ccd3'
          ],
          label: '#bbbbbb',
          labelLine: '#bbbbbb'
        },
        white: {
          color: [
            '#37A2DA',
            '#32C5E9',
            '#67E0E3',
            '#7992B1',
            '#FFDB5C',
            '#FF9F7F',
            '#FB7293',
            '#E062AE',
            '#E690D1',
            '#E7BCF3',
            '#9D96F5',
            '#8378EA',
            '#96BFFF',
            '#C52B12',
            '#DD6B66',
            '#e69d87',
            '#FACD89',
            '#8dc1a9',
            '#759aa0',
            '#73b9bc',
            '#749f83',
            '#6e7074',
            '#546570',
            '#2f4554',
            '#bda29a',
            '#c4ccd3'
          ],
          label: '#000000',
          labelLine: '#535353'
        }
      }
    };
  },
  methods: {
    onSelectChange(val){
      this.date.lgt=val;
    },
    // 设置数据最后更新日期（选中日期）；接口请求使用
    setLastDate(dateName) {
      // 交易所变更披露时间方式，临时开关！
      const { switchChangeTime, latestDate } = this.configInfo[dateName];
      let showTime = switchChangeTime || latestDate;
      if(latestDate && (new Date(latestDate)<new Date(showTime))) {
        showTime = latestDate;
      }
      if(dateName === 'lgt'){
        return;
      }
      this.date[dateName] = showTime.split('-').join('');
      this.setStopDate();
    },
    // 设置日历截止时间 switchChangeTime，默认当前时间 this.currDate
    setStopDate() {
      for (const dateName of Object.keys(this.configInfo)) {
        // 交易所变更披露时间方式，临时开关！
        const { switchChangeTime } = this.configInfo[dateName];
        const switchDate = new Date(switchChangeTime);
        switchDate.setDate(switchDate.getDate()+1);
        // 日历组件上限时间（不包含）
        let showTime = switchChangeTime ? switchDate.getTime() : this.currDate;
        if(this.currDate && (new Date(this.currDate)<new Date(showTime))) {
          showTime = this.currDate;
        }
        if(showTime){
          // 时间戳
          this.configInfo[dateName].stopDate = showTime;
          const date = new Date(this.configInfo[dateName].stopDate);
          this.configInfo[dateName].year = date.getFullYear();
        }
      }
    },
    // 最后显示日期
    getSwitchDate() {
      // 默认交易所变更时间, 最后显示日期
      const defaultChangeTime = '2024-08-18';

      // 该项目功能数据全部暂停更新；后续产品侧重构或下线！！
      for (const dateName of Object.keys(this.configInfo)) {
        this.configInfo[dateName].switchChangeTime = defaultChangeTime;
        this.setLastDate(dateName);
      }
    },
    setItemShow() {
      for (let key of Object.keys(this.selItem)) {
        if (this.selItem[key] === false) {
          this.getAllmarkettradeday(2);
          this.selItem[key] = true;
          break;
        }
      }
    },
    handleNowTime(currDate) {
      this.currDate = (currDate || Date.now()) - HOUR_TO_SEC * BACK_HOURS * SEC_TO_MSILLISEC;
      this.setStopDate();
      this.getDateList();
    },
    typeName(type) {
      if (type === 'lgt') {
        return '陆股通';
      } else {
        return '港股通';
      }
    },
    selectItem(e) {
      let type = e.type;
      let item = e.value;
      let arr = [type, item];
      this.$emit('update:selected', arr);
      if (type === 'lgt') {
        if (item === 'sctj') {
          TA.log({ id: 'cgpz_lgt_sctj_11', _sid: 'cgpz_lgt_sctj_11' });
        }
        if (item === 'zstj') {
          TA.log({ id: 'cgpz_lgt_zstj_11', _sid: 'cgpz_lgt_zstj_11' });
        }
        if (item === 'hytj') {
          TA.log({ id: 'cgpz_lgt_hytj_11', _sid: 'cgpz_lgt_hytj_11' });
        }
        if (item === 'zcgtj') {
          TA.log({ id: 'cgpz_lgt_zctj_11', _sid: 'cgpz_lgt_zctj_11' });
        }
      } else {
        if (item === 'sctj') {
          TA.log({ id: 'cgpz_ggt_sctj_11', _sid: 'cgpz_ggt_sctj_11' });
        }
        if (item === 'zstj') {
          TA.log({ id: 'cgpz_ggt_zstj_11', _sid: 'cgpz_ggt_zstj_11' });
        }
        if (item === 'hytj') {
          TA.log({ id: 'cgpz_ggt_hytj_11', _sid: 'cgpz_ggt_hytj_11' });
        }
        if (item === 'zcgtj') {
          TA.log({ id: 'cgpz_ggt_zctj_11', _sid: 'cgpz_ggt_zctj_11' });
        }
      }
    },
    downloadData(index) {
      let type;
      let date;
      if (index === 'lgt') {
        type = 1;
        date=util.time.format(this.date[index] * 1000, '');
      } else {
        type = 2;
        date = this.date[index];
      }
      // this.$http.get('//zx.10jqka.com.cn/offshorefunds/holdconfiguration/exportexcelpermission').then(data=>{
      //   data = data.data
      //   if(data.err_code){
      //     console.log(data.error_msg)
      //   }else{
      //     this.downloadUrl = '//zx.10jqka.com.cn/offshorefunds/holdconfiguration/exportexcel?type='+type+'&date='+date
      //     document.getElementById("downloadData").click();
      //   }
      // })
      $.ajax({
        type: 'GET',
        url: '//zx.10jqka.com.cn/offshorefunds/holdconfiguration/exportexcelpermission',
        dataType: 'jsonp',
        success: data => {
          if (data.error_code) {
            this.downloadTips = true;
            setTimeout(() => {
              this.downloadTips = false;
            }, 1500);
          } else {
            if (index === 'lgt') {
              TA.log({ id: 'cgpz_lgt_xz' });
            } else {
              TA.log({ id: 'cgpz_ggt_xz' });
            }
            this.downloadUrl = '//zx.10jqka.com.cn/offshorefunds/holdconfiguration/exportexcel?type=' + type + '&date=' + date;
            setTimeout(() => {
              document.getElementById('downloadData').click();
            }, 50);
          }
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    getDateList() {
      this.getAllmarkettradeday(1);
    },
    // 替换日期接口
    getAllmarkettradeday(type) {
      // 陆股通使用新的日期接口
      if (type === 1) {
        $.ajax({
          type: 'GET',
          url: `//apigate${process.env.NODE_ENV !== 'production' ? '-test' : ''}.10jqka.com.cn/d/hq/hshkconnect/basedata/date_calendar/v1/get_quarter_date_calendar`,
          data: {
            cate: 'lgt_stock_holding',
            type: 'north'
          },
          dataType: 'json',
          cache: true,
          success: response => {
            if (response.status_code === 0) {
              const { data } = response;
              this.dealDate(data.items, type);
            }
          },
          error: function (e) {
            console.log(e);
          }
        });
      }
      // 处理港股通日期列表
      const dateName = REVERSED_KEYMAP[type];
      const year = this.configInfo[dateName].year;
      let jsonpCallback = `allmarkettradeday_${+new Date()}`;
      $.ajax({
        type: 'GET',
        url: '//zx.10jqka.com.cn/offshorefunds/hsgttradeday/allmarkettradeday',
        data: {
          year: year,
          type: type
        },
        dataType: 'jsonp',
        cache: true,
        jsonpCallback: jsonpCallback,
        success: data => {
          if (data.error_code) {
            console.log(data.error_msg);
          }
          if (data.result && data.result.length) {
            // 这里只处理港股通日期列表
            this.dealDate(data.result, 2);
          }
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    dealDate(result, type) {
      let condition = [1, 2];
      let conditionRange = ['lgt', 'ggt'];
      let conditionResult = conditionRange[condition.indexOf(type)];
      let dateList = result || [];
      // 陆股通处理日期列表
      if(type === 1){
        this.quarterOptions = dateList.map(item=>({
          label:item.name,
          value:item.timestamp
        }))
        // 默认选中最后一个
        this.date[conditionResult] = this.quarterOptions.length ? this.quarterOptions[this.quarterOptions.length - 1].value : '';
        return;
      }
      // 处理港股通日期列表
      let t = $util.time.format(this.configInfo[conditionResult].stopDate, '');

      let arr = [];
      for (let i = 0; i < dateList.length; i++) {
        if (dateList[i] - 0 < t - 0 && dateList[i] - 0 > 20170106) {
          arr.push(dateList[i]);
        }
      }
      dateList = arr;
      this.dateList[conditionResult] = dateList;
      let curr = dateList[dateList.length - 1];
      if (curr) {
        this.getLatestDate(type, conditionResult, curr);
        // this.date.lgt = curr;
      } else {
        if (this.limit > 10) return;
        this.configInfo[REVERSED_KEYMAP[type]].year--;
        this.getAllmarkettradeday(type);
        this.limit++;
      }
    },
    getLatestDate(type, dateName, curr) {
      // zx.10jqka.com.cn/offshorefunds/holdconfiguration/getlatestdataday 接口已失效，该项目功能 后续产品侧重构或下线！！
      this.configInfo[dateName].latestDate = '2024-08-16';
      this.setLastDate(dateName);
    },
    target(e) {
      let type = e.type;
      let item = e.value;
      if (type === 'lgt') {
        if (item === 'sctj') {
          TA.log({ id: 'cgpz_lgt_sctj_20', _sid: 'cgpz_lgt_sctj_20' });
        }
        if (item === 'zstj') {
          TA.log({ id: 'cgpz_lgt_zstj_20', _sid: 'cgpz_lgt_zstj_20' });
        }
        if (item === 'hytj') {
          TA.log({ id: 'cgpz_lgt_hytj_20', _sid: 'cgpz_lgt_hytj_20' });
        }
        if (item === 'zcgtj') {
          TA.log({ id: 'cgpz_lgt_zctj_20', _sid: 'cgpz_lgt_zctj_20' });
        }
      } else {
        if (item === 'sctj') {
          TA.log({ id: 'cgpz_ggt_sctj_20', _sid: 'cgpz_ggt_sctj_20' });
        }
        if (item === 'zstj') {
          TA.log({ id: 'cgpz_ggt_zstj_20', _sid: 'cgpz_ggt_zstj_20' });
        }
        if (item === 'hytj') {
          TA.log({ id: 'cgpz_ggt_hytj_20', _sid: 'cgpz_ggt_hytj_20' });
        }
        if (item === 'zcgtj') {
          TA.log({ id: 'cgpz_ggt_zctj_20', _sid: 'cgpz_ggt_zctj_20' });
        }
      }
    },
    tipText(dateName) {
      const { switchChangeTime } = this.configInfo[dateName];
      if (!switchChangeTime) {
        return '';
      }
      const switchDate = new Date(switchChangeTime);
      switchDate.setDate(switchDate.getDate() + 1);
      const year = switchDate.getFullYear();
      const month = switchDate.getMonth() + 1;
      const day = switchDate.getDate();
      if (dateName === 'lgt') {
        return `温馨提示：自${year}年${month}月${day}日起，按照上交所、深交所、港交所关于沪深港通信息披露规定，该页面数据将按季度进行更新。`;
      } else {
        return '';
      }
    }
  },
  computed: {
    typeSelected() {
      return this.selected[0];
    },
    itemSelected() {
      return this.selected[1];
    }
  },
  watch: {
    date(val, old) {
      console.log(arguments);
    },
    selected(newval, oldval) {
      if (newval !== oldval) {
        if (this.selItem[newval[0]] === false) {
          this.getAllmarkettradeday(2);
        }
        this.selItem[newval[0]] = true;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download-tips {
  position: absolute;
  color: #fff;
  background-color: rgba(30, 30, 30, 0.7);
  top: 50%;
  right: 38%;
  z-index: 9999;
  width: 350px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 2px 2px 3px -2px #fff;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* color: #ffffff; */
  /* min-width: 880px; */
}
.content-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 9px 4px;
  white-space: nowrap;
}
.top-title {
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  margin-left: 10px;
  overflow: hidden;
}
.block-title {
  position: relative;
  height: 26px;
  font-size: 12px;
  line-height: 26px;
  padding-left: 5px;
}
.title-tips {
  position: relative;
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #6a6e74;
  text-align: center;
  line-height: 13px;
  cursor: default;
}
.tips {
  position: absolute;
  display: none;
  width: 400px;
  background-color: rgba(30, 30, 30, 0.7);
  text-align: left;
  border-radius: 5px;
  padding: 15px;
  top: -4px;
  left: 20px;
  z-index: 999;
  line-height: 20px;
  font-size: 13px;
}
.tips-title {
  font-size: 14px;
  margin: 0 0 4px;
}
.tips-content {
  font-size: 12 px;
}
.title-tips:hover .tips {
  display: block;
}
.top-right {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  height: 20px;
  line-height: 20px;
}
.content-container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 2px;
  /* min-width: 820px; */
}
.content-block {
  width: 40%;
  flex-grow: 1;
  min-width: 840px;
  margin: 0 2px 4px;
}
.block-selected {
  border: solid 1px #1882a5;
}
.lgt-tip {
  font-size: 12px;
  padding-left: 10px;
  margin-right: 20px;
  overflow: hidden;
}
.select-box {
  outline: none;
  font-size: 14px;
  max-height: 200px; /* 设置最大高度 */
  overflow-y: auto !important; /* 添加垂直滚动条 */
}
</style>
<style>
.quarter-select{
  margin-right: 10px;
  transform: translateY(-3px);
}
.quarter-select .el-input__inner{
  width: 130px;
    background-color: var(--bg-select-color);
    border: 1px solid rgba(255,255,255,0.2);
    color: var(--text-select-color);
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue